// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
button .bi-upload {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/button/button.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAAI;EACF,eAAA;EACA,WAAA;EACA,YAAA;AAEF","sourcesContent":["button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    & .bi-upload {\n\t\tfont-size: 1rem;\n\t\twidth: 1rem;\n\t\theight: 1rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
